module.exports = __webpack_public_path__ + "assets/img/avatar-profile-group.svg";